// https://vuex.vuejs.org/en/state.html

export default {
  user: null,
  userSettings: null,
  userPermissions: null,
  isSharingWhitelabels: false,
  isInvite: false
};
